class VideoControl{
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const video = '.js-video';
    $(video).on('click', function() {
      var videoElement = $(this).get(0); // jQuery オブジェクトからネイティブの video 要素を取得
      if ($(this).hasClass('is-play')) {
        videoElement.pause(); // ビデオを一時停止
      } else {
        videoElement.play(); // ビデオを再生
      }
      $(this).toggleClass('is-play');
    });

  }
}
